const prices = () => {

    // const pricesBlock = document.querySelector('.price-count');
    const jsonData = document.querySelector('[data-id="json-data"]'),
        inputRange = document.querySelector('[data-id="weights"]'),
        location = document.querySelector('[data-id="location-select"]'),
        currentWeight = document.querySelector('[data-id="current-weight"]'),
        currentPrice = document.querySelector('[data-id="current-price"]'),
        calcBlock = document.querySelector('[data-id="prices__calc"]');

    if (!jsonData && !inputRange && !location && !currentWeight && !currentPrice && !calcBlock) {
        return;
    }

    // default settings
    let values = JSON.parse(jsonData.innerHTML);
    values && jsonData.remove();

    setMaxRange(values, location);

    $('[data-id="location-select"]').on("change", () => {
        inputRange.value = "0";
        setResults(inputRange);
        setMaxRange(values, location);
    });

    calcBlock.addEventListener("input", (e) => {
        switch (e.target) {
            case location:
                // update maxRange according to location change
                inputRange.value = "0";
                setResults(inputRange);
                setMaxRange(values, location);
                break;

            case inputRange:
                // updating weight and price on range change
                setResults(e.target);
                break;

            default:
                break;
        }
    });

// function for setting input max range according to length of the values array
    function setMaxRange(obValues, locKey) {
        inputRange.setAttribute("max", obValues[locKey.value - 1].values.length - 1);
    }

// function for set & update results on front
    function setResults(target) {
        currentWeight.innerHTML =
            values[location.value - 1].values[target.value].weight;
        currentPrice.innerHTML =
            values[location.value - 1].values[target.value].price;
    }
}

export default prices;


// WEBPACK FOOTER //
// ./scripts/modules/prices.js